import { useCallback, useState } from 'react'
import { CreateProjectArgs } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ProjectsAPI } from 'controllers/Projects/ProjectsAPI'
import { ErrorMessage, ShowNewProjectForm } from 'store/Application/appActions'
import { useOrganizationContext } from 'utils/useOrganizationContext'
import { ValidationErrorAsString } from 'utils/validationErrorAsString'
import { useAppDispatch } from 'store/configureStore'
import { useNavigate } from 'react-router-dom'

export function useCreateProject() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { organizationId, isBuyingParty } = useOrganizationContext()
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = useCallback(
    async (createProjectArgs: CreateProjectArgs) => {
      const api = new ProjectsAPI(organizationId)

      try {
        setSubmitting(true)

        createProjectArgs.isBuyerParty = isBuyingParty

        // fix a bug with backend's validation
        // remove it when backend validate the address by code and not by name
        if (
          !createProjectArgs.buyerPartyDto.address?.country?.name &&
          createProjectArgs.buyerPartyDto.address?.country?.code
        ) {
          createProjectArgs.buyerPartyDto.address.country.name =
            createProjectArgs.buyerPartyDto.address.country.code
        }

        if (isBuyingParty) {
          createProjectArgs.buyerPartyDto.contactPerson = {
            ...createProjectArgs.buyerPartyDto.contactPerson,
            id: undefined,
          }
        }

        const resp = await api.CreateNewProject(createProjectArgs)

        dispatch(ShowNewProjectForm(false, undefined))

        setTimeout(() => {
          navigate(`/app/project/${encodeURI(resp)}`)
        }, 100)

        return Promise.resolve(undefined)
      } catch (err) {
        const appError: {
          validation: Record<string, string>
          message: string
        } = err as never

        if (appError.validation) {
          // form validation error
          ErrorMessage(
            'create project',
            ValidationErrorAsString(appError.validation)
          )
          return Promise.resolve(appError.validation)
        }
        ErrorMessage(
          'create project',
          appError.message || JSON.stringify(appError.validation, null, 2)
        )
        return Promise.reject(appError.message)
      } finally {
        setSubmitting(false)
      }
    },
    [dispatch, isBuyingParty, organizationId, navigate]
  )

  return { handleSubmit, submitting, setSubmitting }
}
